module.exports = __webpack_public_path__ + "img/2-min.e02884c8.jpg";